/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TradeImportLogListDto,
    TradeImportLogListDtoFromJSON,
    TradeImportLogListDtoToJSON,
} from '../models';

export interface TradeImportLogControllerGetListRequest {
    portfolioId: string;
    limit: number;
    offset: number;
}

export interface TradeImportLogControllerRevertRequest {
    id: string;
}

/**
 * 
 */
export class ImportLogTradesApi extends runtime.BaseAPI {

    /**
     * Get trade import logs by portfolioId
     */
    async tradeImportLogControllerGetListRaw(requestParameters: TradeImportLogControllerGetListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<TradeImportLogListDto>> {
        if (requestParameters.portfolioId === null || requestParameters.portfolioId === undefined) {
            throw new runtime.RequiredError('portfolioId','Required parameter requestParameters.portfolioId was null or undefined when calling tradeImportLogControllerGetList.');
        }

        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling tradeImportLogControllerGetList.');
        }

        if (requestParameters.offset === null || requestParameters.offset === undefined) {
            throw new runtime.RequiredError('offset','Required parameter requestParameters.offset was null or undefined when calling tradeImportLogControllerGetList.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/trades/import-log/{portfolioId}`.replace(`{${"portfolioId"}}`, encodeURIComponent(String(requestParameters.portfolioId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TradeImportLogListDtoFromJSON(jsonValue));
    }

    /**
     * Get trade import logs by portfolioId
     */
    async tradeImportLogControllerGetList(requestParameters: TradeImportLogControllerGetListRequest, initOverrides?: RequestInit): Promise<TradeImportLogListDto> {
        const response = await this.tradeImportLogControllerGetListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update trade
     */
    async tradeImportLogControllerRevertRaw(requestParameters: TradeImportLogControllerRevertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tradeImportLogControllerRevert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/trades/import-log/revert/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update trade
     */
    async tradeImportLogControllerRevert(requestParameters: TradeImportLogControllerRevertRequest, initOverrides?: RequestInit): Promise<void> {
        await this.tradeImportLogControllerRevertRaw(requestParameters, initOverrides);
    }

}
